
namespace TabAurous.Reports { 
    @Serenity.Decorators.registerClass()
    export class CategoryWiseEditor extends _Ext.GridEditorBase<Sales.SalesItemsRow> {
        protected getColumnsKey() { return "Sales.CategoryWiseQuarterlySales"; }
         
         
        constructor(container: JQuery) {
            super(container); 

        } 
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row) as Sales.SalesItemsRow;
            //To Set Master Product Image
            if (!isNaN(item.CategoryId)) {
                var categoryid = item.CategoryId;
                (this.parentDialog as Common.SalesSummaryReportDialog).setGrids(categoryid); 
            }
            var target = $(e.target);
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid(); 
            grid.setSelectionModel(new Slick.RowSelectionModel());


            //var plugin = new Slick.ColumnGroup();
            //grid.registerPlugin(plugin);
            //var columns = grid.getColumns();

            ////grid.registerPlugin(new Slick.columng);

            //for (let col of columns) {
            //    //console.log(col);
            //    if (col.field == "CategoryName") col.groupName = "Category";

            //    if (col.field == "Quarter1Pieces" || col.field == "Quarter1Amount") col.groupName = "Quarter 1";
            //    if (col.field == "Quarter2Pieces" || col.field == "Quarter2Amount") col.groupName = "Quarter 2";
            //    if (col.field == "Quarter3Pieces" || col.field == "Quarter3Amount") col.groupName = "Quarter 3";
            //    if (col.field == "Quarter4Pieces" || col.field == "Quarter4Amount") col.groupName = "Quarter 4"; 
            //}

            //plugin.enableColumnGrouping();

            //grid.setColumns(columns); 
            //grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }
        public setdata(items: Sales.SalesItemsRow[], response) {
            this.setItems([]);
            for (let item of items) {
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }

            this.onViewProcessData(response);
        }
        public setselectedrow(row: number) {
            this.slickGrid.setSelectedRows([row]);

        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        } 
        
    }
}